import { userIsAdmin } from '@redviking/argonaut-core-ui/src/auth';
import type { ValidationResult } from 'types';
import type { UserEntity } from './user.entity';

export function isAdmin (): boolean {
    return userIsAdmin();
}

export const userValidations = (user: UserEntity): ValidationResult => {
    if (!user.username || user.username.length <= 0) {
        return {
            status: 'error',
            errorMessage: 'Username required',
        };
    }
    return {
        status: 'success',
    };
};
